import instance from "./helpers/instance";
const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;

const fetchEULA = async (wlpId) => {
  return {
    privacy_policy_url: `https://www.maxicare.com.ph/privacy-notice/`,
    terms_of_service_url: `https://maxicare.ph/MaxicareeHealth`,
  }
};

export {
  fetchEULA,
}